import { SEARCH_ERROR } from "./const";

const action = (error, lastFilter) => {
  return {
    type: SEARCH_ERROR,
    error,
    lastFilter,
  };
};

export default action;
